class MuSubmenuMain extends HTMLElement {
    constructor() {
        super();
        this.openedBy = null;
    }

    connectedCallback() {
        this.drawer = this.querySelector('#mu-header__menu-submenu-dropdown');
        this.triggers = document.querySelectorAll('[data-action="open-mu-submenu"]');
        this.keypressTriggers = document.querySelectorAll('[data-action="open-mu-submenu-keypress"]');
        this.submenus = this.querySelectorAll('.mu-header__menu-submenu-dropdown-content');

        // All Event Listeners
        this.triggers.forEach(trigger => {
            trigger.addEventListener('click', this.handleMouseOpen.bind(this));
            trigger.addEventListener('mouseenter', this.handleMouseOpen.bind(this));
        });
        this.keypressTriggers.forEach(trigger => {
            trigger.addEventListener('mouseenter', this.handleMouseOpen.bind(this));
            trigger.addEventListener('keydown', this.handleKeypressOpen.bind(this));
        });
        this.drawer?.addEventListener('mouseleave', (event) => {
            if (this.openedBy !== 'mouse') return;
            const nextElement = event.relatedTarget;
            // If mouse moved to the header menu list, don't close
            const stillInMenuItem = nextElement?.closest('.mu-header__menu-list');

            if (!stillInMenuItem) {
                this.closeAll();
            }
        });

        window.addEventListener('resize', this.closeAll.bind(this));
        document.addEventListener('keydown', this.handleKeyDown.bind(this));
        document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    /* ----------------------------- */
    /* OPENING LOGIC                 */
    /* ----------------------------- */

    handleMouseOpen(event) {
        this.openedBy = 'mouse';
        this.openMenu(event.currentTarget);
    }
    handleKeypressOpen(event) {
        this.openedBy = 'key';
        this.openMenu(event.currentTarget);
    }

    openMenu(trigger) {
        if (!(trigger instanceof HTMLElement)) return;
    
        const handle = trigger.dataset?.muSubmenuHandle;
        document.documentElement.setAttribute("scroll-lock", "");
    
        let openDrawer = false;
        this.submenus?.forEach(submenu => {
            // If there is a submenu with the same handle as the menu item trigger, open it
            if (submenu.dataset?.muSubmenuHandle === handle) {
                openDrawer = true;
                submenu.setAttribute("openStatus", "open");
    
                // Focus inside the submenu
                if(this.openedBy === 'key') {
                    requestAnimationFrame(() => {
                        const firstFocusable = submenu.querySelector(
                            'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
                        );
                        firstFocusable?.focus();
                    });
                }
            // else: close the submenu (e.g. for menu items that don't have a submenu)
            } else {
                submenu.setAttribute("openStatus", "closed");
            }
        });
        // Add the active attribute to the menu item that is currently open
        this.triggers?.forEach(triggerEl => {
            const li = triggerEl.closest('.mu-header__menu-item');
            if (triggerEl.dataset?.muSubmenuHandle === handle) {
                li?.setAttribute('active', '');  // add the active attribute
            } else {
                li?.removeAttribute('active');   // remove it from others
            }
        });
        if(openDrawer) {
            this.drawer?.setAttribute("openStatus", "open");
        } else {
            this.drawer?.setAttribute("openStatus", "closed");
        }
    }

    /* ----------------------------- */
    /* CLOSING LOGIC                 */
    /* ----------------------------- */

    closeAll() {
        // Only remove scroll-lock if the mobile drawer is not open
        const mobileDrawerOpen = document.querySelector('mu-mobile-menu-drawer[open]');
        if (!mobileDrawerOpen) {
            document.documentElement.removeAttribute('scroll-lock');
        }
        this.openedBy = null;
        // Remove the active attribute from the menu item that is currently open
        this.triggers?.forEach(triggerEl => {
            const li = triggerEl.closest('.mu-header__menu-item');
            li?.removeAttribute('active');   // remove it from others
        });

        this.submenus?.forEach(submenu => {
            submenu.setAttribute("openStatus", "closed");
        });
        this.drawer?.setAttribute("openStatus", "closed");
    }
    handleKeyDown(event) {
        if (event.key === 'Escape') {
            this.closeAll();
        }
    }

    /* ----------------------------- */
    /* UTILITY FUNCTIONS             */
    /* ----------------------------- */

    handleOutsideClick(event) {
        if (!this.contains(event.target)) {
            this.closeAll();
        }
    }
}

customElements.define('mu-submenu-main', MuSubmenuMain);